// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from './btnPermission'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import 'font-awesome/css/font-awesome.css'
import 'nprogress/nprogress.css'
import './assets/comm.css'
import './utils/dialogexp'


import NProgress from 'nprogress'
import App from './App.vue'
import router from './router'
import store from './vuex'
import i18n from './i18n/i18n'
import axios from './axios'
import common from './utils/common'
import date from './utils/date'
document.body.parentNode.style.overflow = "hidden";
NProgress.configure({ showSpinner: true })
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(common);
Vue.use(date);
Vue.prototype.$open = function (url) {
  window.open(url);
};
Vue.prototype.$axios = axios;
Vue.prototype.$url = window.server.img_url;
Vue.prototype.$fileUrl = window.server.fileserver;
Vue.prototype.$apiurl = window.server.apihost;
Vue.prototype.$logouturl = window.server.logouthost;
// if(process.env.NODE_ENV === 'development')
//   router.addRoutes(addRouter)
if (!store.getters.formLogin)
{
  store.dispatch('newRoutes', store.getters.rolenames)
  router.addRoutes(store.getters.addRouters);
}
//  获取角色信息，根据用户权限动态加载路由
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (store.getters.token && store.getters.user.EntType == 'Seed')
  {
    //store.dispatch('setToken', store.getters.token)
    if (to.path === '/login')
    {
      next({ path: '/' })
      NProgress.done()
    } else
    {

      let is404 = to.matched.length == 0 || to.matched.some(record => {
        if (record.meta.role)
        {
          return record.meta.role.filter(x => store.getters.rolenames.indexOf(x) > -1).length == 0
        }
      })
      if (is404)
      {
        next({ path: '/404' })
        NProgress.done()
        return false
      }
      next()
      NProgress.done()
    }
  } else
  {
    if (to.path === '/login' || to.path === '/local')
    {
      next()
      NProgress.done()
    }
    else
    {
      next({ path: '/login' })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js